import { useContext } from "react";
import { DMWebsocketContext } from "../contexts/DMWebsocketContext";

export const useDMWebsocket = () => {
  const { sendDMListing, sendMessage, sendTyping, sendStopTyping, readyState } =
    useContext(DMWebsocketContext);
  return { sendDMListing, sendMessage, sendTyping, sendStopTyping, readyState };
};
